<app-breadcrumb
  [master]="'Rozliczenia'"
  [parentName]="'Tabele prowizyjne'"
  [name]="'Lista tabel'"
></app-breadcrumb>

<div
  class="commission-table-list-container"
  fxLayout="column"
  fxLayoutGap="15px"
>
  <form
    (keyup.enter)="filter()"
    (submit)="filter()"
    #filtersForm="ngForm"
  >
    <mat-form-field
      style="display: none"
      class="commission-table-list-filter"
    >
      <mat-label>UUID</mat-label>

      <input
        matInput
        name="uuid"
        [(ngModel)]="initialFilters.uuid"
      >
    </mat-form-field>

    <mat-form-field
      appearance="standard"
      class="commission-table-list-filter"
    >
      <mat-label>Nazwa</mat-label>

      <input
        matInput
        placeholder="Nazwa"
        name="name"
        [(ngModel)]="initialFilters.name"
      >
    </mat-form-field>

    <mat-form-field
      appearance="standard"
      class="commission-table-list-filter"
    >
      <mat-label>Nazwa skrócona</mat-label>

      <input
        matInput
        placeholder="np. 2026.1"
        name="shortName"
        [(ngModel)]="initialFilters.shortName"
      >
    </mat-form-field>

    <app-datepicker
      class="commission-table-list-filter"
      label="Obowiązuje od"
      placeholder="2026-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$validFrom"
      name="gte$validFrom"
    ></app-datepicker>

    <app-datepicker
      class="commission-table-list-filter"
      label="Obowiązuje do"
      placeholder="2026-12-31"
      [required]="false"
      [(ngModel)]="initialFilters.lte$validTo"
      name="lte$validTo"
    ></app-datepicker>
  </form>

  <div
    fxLayout="row"
    fxLayoutGap="15px"
  >
    <button
      routerLink="/tabele-prowizyjne/dodaj"
      [disabled]="!(userPermissions | async).settlement.write"
      mat-raised-button
      color="accent"
    >
      <mat-icon>add</mat-icon>
      <span> Dodaj tabelę</span>
    </button>

    <span fxFlex></span>

    <div
      fxLayout="row"
      fxLayoutGap="15px"
      fxLayoutAlign="center center"
    >
      <button
        (click)="filter()"
        mat-raised-button
        color="primary"
      >
        <mat-icon>search</mat-icon>
        <span> Szukaj</span>
      </button>

      <button
        (click)="resetFilters()"
        mat-raised-button
        color="warn"
      >
        <mat-icon>delete</mat-icon>
        <span> Resetuj filtry</span>
      </button>
    </div>
  </div>

  <div fxLayout="column" fxFlex="100">

    <table mat-table [dataSource]="items">

      <ng-container matColumnDef="shortName">
        <th mat-header-cell *matHeaderCellDef>
          Nazwa skrócona
        </th>

        <td mat-cell *matCellDef="let element">
          <a
            class="default-link"
            [routerLink]="[
    '/tabele-prowizyjne/szczegoly',
    element.uuid
  ]"
          >{{ element.shortName }}</a>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>
          Nazwa
        </th>

        <td mat-cell *matCellDef="let element">
          {{ element.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="validFrom">
        <th mat-header-cell *matHeaderCellDef>
          Data od
        </th>

        <td mat-cell *matCellDef="let element">
          {{ element.validFrom | date:'y-MM-dd' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="validTo">
        <th mat-header-cell *matHeaderCellDef>
          Data do
        </th>

        <td mat-cell *matCellDef="let element">
          {{
            element.validTo
              ? (element.validTo | date:'y-MM-dd')
              : '-'
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="sourceTable">
        <th mat-header-cell *matHeaderCellDef>
          Tabela źródłowa
        </th>

        <td mat-cell *matCellDef="let element">
          {{ element.sourceTableShortName || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="assignments">
        <th mat-header-cell *matHeaderCellDef>
          Przypisania
        </th>

        <td mat-cell *matCellDef="let element">

          <ng-container
            *ngFor="let assignment of element.assignments"
          >
            <div class="commission-table-assignment">
              {{ assignment.companyName }}
              /
              {{ assignment.contractTypeName }}
            </div>
          </ng-container>

        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>

        <td mat-cell *matCellDef="let element">
          <button
            mat-icon-button
            color="accent"
            matTooltip="Szczegóły"
            [routerLink]="[
        '/tabele-prowizyjne/szczegoly',
        element.uuid
      ]"
          >
            <mat-icon>visibility</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns"
      ></tr>

      <tr
        mat-row
        class="table-row"
        *matRowDef="let row; columns: displayedColumns;"
      ></tr>

    </table>

    <mat-paginator
      #paginator
      [pageSizeOptions]="[10, 20, 50]"
      [length]="totalData"
    ></mat-paginator>

  </div>
</div>
